export default __webpack_public_path__ + "static/media/6.2421e282.jpg";